var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import Icon from '../icon/Icon';
import { mdiAlertCircleOutline, mdiAlertOutline, mdiCheckCircleOutline, mdiInformationOutline, } from '@mdi/js';
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Alert.prototype.render = function () {
        var _a = this.props, className = _a.className, classNameContainer = _a.classNameContainer, message = _a.message, color = _a.color, iconColor = _a.iconColor, iconPath = _a.iconPath, iconPosition = _a.iconPosition, iconSize = _a.iconSize, onClick = _a.onClick, href = _a.href, target = _a.target, _b = _a.isShowIcon, isShowIcon = _b === void 0 ? true : _b;
        var classNameResult = className + ' ac-alert ' + color + (onClick ? ' cursor-pointer' : '');
        var getDefaultIcon = function () {
            switch (color) {
                case 'danger':
                    return mdiAlertCircleOutline;
                case 'success':
                    return mdiCheckCircleOutline;
                case 'warning':
                    return mdiAlertOutline;
                default:
                    return mdiInformationOutline;
            }
        };
        var children = (React.createElement("div", { className: "d-flex align-items-" + (iconPosition || 'center') + " w-100 " + classNameResult },
            isShowIcon && (React.createElement(Icon, { path: iconPath !== null && iconPath !== void 0 ? iconPath : getDefaultIcon(), color: iconColor, size: iconSize !== null && iconSize !== void 0 ? iconSize : 0.67, className: 'feedback-icon' })),
            message));
        if (href) {
            return (React.createElement("a", { href: href, target: target, className: classNameContainer ? classNameContainer : 'd-flex align-items-center ', onClick: onClick }, children));
        }
        else {
            return (React.createElement("div", { className: classNameContainer ? classNameContainer : 'd-flex align-items-center ', onClick: onClick }, children));
        }
    };
    return Alert;
}(Component));
export default Alert;
//# sourceMappingURL=Alert.js.map